export default "__VITE_ASSET__tgNB1rDu__"